<script>
    import { toast } from 'bulma-toast';
    import html2canvas from "html2canvas";
    import jsPDF from "jspdf";
    import page from "page";
    import { onMount } from "svelte";
    import SvelteTable from "svelte-table";
    import client from "../client";
    import ClockAnimation from "../components/images/ClockAnimation.svelte";
    import Dog from "../components/images/Dog.svelte";
    import { convertDateTimeMonthAndDay } from "../utils/dates";
    export let params;

    onMount(async () => {
        if (params.e && params.a) {
          if (/^\d+$/.test(params.e)) {
            try {
              loading = true;
              let event_ = await client.service('results').get(params.e);
              if (event_.name == "NotFound") {
                loading = false;
              } else {
                let result_ = {
                  activities: event_.activities,
                  id: event_.id,
                  name: event_.name,
                  start_date: event_.start_date,
                  venue_id: event_.venue_id,
                  venue_name: "",
                };
                let venue_ = await client.service('results').get(event_.venue_id,{query:{name:"venue"}});
                if (venue_) {
                  result_.venue_name = venue_.name;
                  result(result_);
                  if (/^\d+$/.test(params.a)) {
                    // activity = activities.filter(item => (item.id == params.a))[0];
                    for (let index = 0; index < activities.length; index++) {
                      const act = activities[index];
                      if (act) {
                        if (act.id === parseInt(params.a)) {
                          activity = act;
                        }
                      }
                    }
                    if (activity) {
                      activityResult();
                    } else {
                      loading = false;
                    }
                  } else {
                    loading = false;
                  }
                }
              }
            } catch(err) {
              console.error(err);
              alert_message = err;
              loading = false;
            }
          }
        }
        // console.log(page);
        items = await client.service('results').find({
          query: {
              option : "eventsLast"
          }
        });
    });

    let items = [];
    let show = "list";
    let resultModel;
    let results = [];
    let activities = [];
    let activity;
    let loading = false;
    let alert_message;
    let search = "";
    let export_image = {age: 0,athlete_id: 0,category: "",dog: 0,duration: "00:00:00",gender: "Male",id: 0,name: "",position: 0,position_category: 0,position_gender: 0,race_number: "", surname: ""};

    //Filter Results on name, surname and race_number
    $: filteredList = results.filter(item => (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.surname.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.race_number.toLowerCase().indexOf(search.toLowerCase()) !== -1));

    function result(model) {
      resultModel = model;
      activities = JSON.parse(model.activities);
      activity = null;
      results = [];
      show = "result";
    }

    function exportPDF(item) {
      export_image = item;
      setTimeout(function() {
        let eimage = document.getElementById("exportImage");
        eimage.style.display = "block";
        const filename  = 'RevolutionTrails-Result.pdf';
        html2canvas(document.querySelector('#exportImage'), {scale: 1}
        ).then(canvas => {
          let pdf = new jsPDF({
            orientation: "landscape",
            unit: "px",
            format: [2048,1024]
          });
          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 2048, 1024);
          pdf.save(filename);
        });
        eimage.style.display = "none";
      } , 100);
    }

    async function activityResult() {
      try {
        loading = true;
        results = await client.service('results').find({
          query: {
              option : "activityResult",
              eventid : resultModel.id,
              activityid : activity.id,
          }
        });
        if (results) {
          loading = false;  
        } else {
          alert_message = "No Results Found";
        }
      } catch(err) {
        console.error(err);
        alert_message = err;
        loading = false;
      }
    }

    async function back() {
      resultModel = null;
      show = "list";
    }

    const columns = [
    {
      key: "name",
      title: "Name",
      value: v => v.name,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "activity_name",
      title: "Activity",
      value: v => v.activity_name,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "gender",
      title: "Gender",
      value: v => v.gender,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "category",
      title: "Category",
      value: v => v.category,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "duration",
      title: "Time",
      value: v => v.duration,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "race_number",
      title: "Race Number",
      value: v => v.race_number,
      sortable: false,
      headerClass: "text-left",
    },
    {
      key: "",
      title: "",
      value: "",
      sortable: false,
      headerClass: "text-center",
    },
  ];

  function copyDirectLink(text) {
    var input = document.body.appendChild(document.createElement("input"));
    input.value = "http://results.revolutiontrails.co.za/"+resultModel.id+"/"+activity.id;
    input.focus();
    input.select();
    input.setSelectionRange(0, 99999); /* For mobile devices */
    document.execCommand('copy');
    input.parentNode.removeChild(input);
    toast({
      message: 'Copied to Clipboard.',
      type: 'is-success',
      dismissible: true,
      pauseOnHover: true,
    });
  }

</script>          

<style>
  /* Table Styles */
  div :global(.text-center) {
    text-align: center;
    font-weight: bold;
    font-size: small;
    padding: 2px;
  }
  div :global(.text-left) {
    text-align: left;
    font-weight: bold;
    font-size: small;
    padding: 2px;
  }

  table.greyGridTable {
    font-family: Arial,Verdana,"Times New Roman", Times, serif;
    border: 2px solid #FFFFFF;
    text-align: center;
    border-collapse: collapse;
    width:1220px;
  }
  table.greyGridTable th {
    border: 1px solid #FFFFFF;
    padding: 5px 4px;
  }
  table.greyGridTable td {
    border: 1px solid #FFFFFF;
    padding: 5px 4px;
  }
  table.greyGridTable tbody td {
    font-size: 40px;
  }
  table.greyGridTable td:nth-child(even) {
    background: #EBEBEB;
    text-align: left;
    padding: 5px 10px;
  }
  table.greyGridTable thead {
    background: #FFFFFF;
    border-bottom: 4px solid #333333;
  }
  table.greyGridTable thead th {
    font-size: 44px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    border-left: 2px solid #333333;
  }
  table.greyGridTable thead th:first-child {
    border-left: none;
  }

  table.greyGridTable tfoot {
    font-size: 40px;
    font-weight: bold;
    color: #333333;
    border-top: 4px solid #333333;
  }
  table.greyGridTable tfoot td {
    font-size: 40px;
  }
</style>

{#if show === "list"}
<section class="hero is-info is-medium is-bold">
	<div class="hero-body">
		<div class="container has-text-centered">
			<!-- <h1 class="title">Revolution Trails Results</h1> -->
		</div>
	</div>
</section>          
<section class="articles">
    <div class="column is-8 is-offset-2">
      <div class="card" style="margin-top:10px;">
        <a class="button is-success is-fullwidth" href="/challenge">View Challenges</a>
      </div>
        {#each items as item}
            <div class="card" style="margin-top:10px;">
                <div class="card-content">
                  <p class="title">
                    {item.name}
                  </p>
                  <p class="subtitle">
                    {item.venue_name} - {convertDateTimeMonthAndDay(item.start_date, 2)}
                  </p>
                </div>
                <footer class="card-footer">
                  <p class="card-footer-item">
                    <button class="button is-success is-fullwidth" on:click={result(item)}>View Results</button>
                  </p>
                </footer>
              </div>
        {/each}
    </div>
</section>
{/if}

{#if show === "result"}
<div class="card" style="margin-top:10px;">
  <div class="card-content">
    <p class="title">
      {resultModel.name}
    </p>
    <p class="subtitle">
      {resultModel.venue_name} - {convertDateTimeMonthAndDay(resultModel.start_date, 2)}
    </p>
    
      {#if alert_message}
      <div class="notification is-light is-danger">{@html alert_message}</div>
      {/if}
      <!-- svelte-ignore a11y-no-onchange -->
      <div style="margin-bottom:5px;">
      {#if !activity}
         <h6>Please select activity below:</h6>
      {/if}  
      <select class="input is-primary" bind:value={activity} on:change="{() => activityResult()}" required>
        <option value="" disabled selected>Select Activity</option>
        {#each activities as act}
           <option value={act}>{act.name}</option>
        {/each}
      </select>
      </div>
      {#if loading}
        <div style="width:200px;margin-left:auto;margin-right:auto;">
        <ClockAnimation />
      </div>
      {:else}
      {#if results.length > 0}
        <div class="field is-grouped">
          <p class="control">
            <span class="tag is-primary is-medium">Activity Total : {results.length}</span>
          </p>
          <p class="control is-expanded is-hidden-mobile">
            <input class="input is-small" type="text" bind:value={search} placeholder="Search by Name, Surname, Race Number">
          </p>
          <p class="control">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="button is-warning is-small" on:click={() => search = ''}>
              Clear
            </a>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="button is-info is-small" on:click={() => copyDirectLink()}>
              Copy Direct Link
            </a>
          </p>
        </div>
        <div class="field is-grouped">
          <p class="control is-expanded is-hidden-tablet">
            <input class="input is-small" type="text" bind:value={search} placeholder="Search by Name, Surname, Race Number">
          </p>
        </div>
        <div class="table-container">
        <SvelteTable 
          columns={columns} 
          rows={filteredList} 
          classNameTable={['table is-bordered is-striped is-narrow is-hoverable is-fullwidth ']} 
        >
          <tr slot="row" let:row let:n>
            <td>
              <span>
                <button class="button is-small is-primary" on:click={page.redirect("/athlete/"+row.athlete_id+"/"+row.name+"/"+row.surname)}><span class="icon"><i class="fa fa-user"></i></span></button>
                {row.name} {row.surname}
              </span>
              {#if row.dog}
                <span class="icon">
                  <Dog class="" width="12" height="12"/>
                </span>
              {/if}
            </td>
            <td><span class="tag is-link is-small has-text-weight-bold">{row.position}</span> {activity.name}</td>
            <td><span class="tag is-link is-small has-text-weight-bold">{row.position_gender}</span> {row.gender}</td>
            <td><span class="tag is-link is-small has-text-weight-bold">{row.position_category}</span> {row.category}</td>
            <td>{row.duration}</td>
            <td>{row.race_number}</td>
            <td style="text-align:center"><button class="button is-small is-success" on:click={exportPDF(row)}><span class="icon"><i class="fa fa-download"></i></span></button></td>
          </tr>
        </SvelteTable>
      </div>
      {/if}
      {#if results.length == 0 && activity}
      <div class="notification is-light is-warning">No Results Found for Selected Activity.</div>
      {/if}
    {/if}
  </div>
  <div id="exportImage" style="width:2048px;font-weight:bold;display:none">
  <div style="padding:0;margin:0;">
    <div style="display: inline-block;width:820px;padding-top:80px;">
      <img src="/images/logo.jpg" width="820px" alt="logo"/>
    </div>
    <div style="display: inline-block;vertical-align: top;width: 1220px;">
      <table class="greyGridTable">
          <thead>
              <tr>
                  <th>Event</th>
                  <th>{resultModel.name}</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td><b>Venue</b></td>
                  <td>{resultModel.venue_name}</td>
              </tr>
              <tr>
                  <td><b>Date</b></td>
                  <td>{convertDateTimeMonthAndDay(resultModel.start_date, 2)}</td>
              </tr>
              <tr>
                  <td><b>Name</b></td>
                  <td>{export_image.name}</td>
              </tr>
              <tr>
                  <td><b>Surname</b></td>
                  <td>{export_image.surname}</td>
              </tr>
              <tr>
                  <td><b>Gender</b></td>
                  <td>{export_image.gender}</td>
              </tr>
              {#if activity}
              <tr>
                <td><b>Activity</b></td>
                <td>{activity.name}</td>
              </tr>
              {/if}
              <tr>
                  <td><b>Category</b></td>
                  <td>{export_image.category}</td>
              </tr>
              <tr>
                  <td><b>Time</b></td>
                  <td>{export_image.duration}</td>
              </tr>
              <tr>
                  <td><b>Race Number</b></td>
                  <td>{export_image.race_number}</td>
              </tr>
          </tbody>
          <tfoot>
              <tr>
                  <td>Position</td>
                  <td>Overall [{export_image.position}] Gender [{export_image.position_gender}] Category [{export_image.position_category}]</td>
              </tr>    
          </tfoot>
      </table>
    </div>
  </div>
</div>
  <footer class="card-footer">
    <p class="card-footer-item">
      <button class="button is-success is-fullwidth" on:click={back}>Back</button>
    </p>
  </footer>
</div>

{/if}
